module.exports = __webpack_public_path__ + "static/media/green.ff15ed48.png";